export default "__VITE_PUBLIC_ASSET__a03a5e67__"